import React, { useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import FAQ from "../../components/FAQ";
import SEO from "../../components/SEO";
import { ContactModal } from "../../components/calltoactions/ContactModal";
import { contact } from "../../config/site";

const faqItems = [
  {
    q: "מהו ייפוי כוח מתמשך ומה ההבדל מייפוי כוח רגיל?",
    a: "ייפוי כוח רגיל מתבטל ברגע שנותן הייפוי כוח מאבד כשירות משפטית. ייפוי כוח מתמשך, לעומת זאת, נועד בדיוק לאותם מצבים — הוא נכנס לתוקף כאשר הנותן אינו יכול עוד לנהל את ענייניו, ותוקפו נמשך.",
  },
  {
    q: "מי יכול להיות ממונה בייפוי כוח מתמשך?",
    a: "כל אדם בגיר הנהנה מאמונכם — בן/בת זוג, ילד, אח, חבר קרוב, או גורם מקצועי. ניתן למנות יותר מאדם אחד, לקבוע סדר עדיפות, ולהגביל את הסמכויות לפי תחומים.",
  },
  {
    q: "מתי ייפוי הכוח המתמשך נכנס לתוקף?",
    a: "ייפוי הכוח המתמשך לא נכנס לתוקף אוטומטית. הוא מופעל על-ידי הממונה לאחר שנותן הייפוי כוח איבד כשירות — בהגשת אישור מרופא מומחה לאפוטרופוס הכללי.",
  },
  {
    q: "האם ניתן להגביל את הממונה?",
    a: "בהחלט. בייפוי הכוח ניתן להגדיר בדיוק אילו החלטות הממונה מוסמך לקבל — החלטות רפואיות, רכושיות, אישיות — וניתן לקבוע הנחיות ומגבלות לפי רצונכם.",
  },
  {
    q: "מה קורה אם לא הכנתי ייפוי כוח מתמשך?",
    a: "ללא ייפוי כוח מתמשך, כאשר אדם מאבד כשירות, הדרך היחידה לניהול ענייניו היא מינוי אפוטרופוס דרך בית המשפט — הליך ארוך, יקר ופוגע באוטונומיה האישית.",
  },
  {
    q: "כמה עולה הכנת ייפוי כוח מתמשך?",
    a: "עלות ההכנה כוללת שכר טרחת עורך הדין ואגרות רישום אצל האפוטרופוס הכללי. אנו מציעים שקיפות מלאה בתמחור — פנו אלינו לקבלת הצעת מחיר.",
  },
];

const PowerOfAttorney = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
  <>
  <PageLayout>
    <SEO
      title="ייפוי כוח מתמשך בבאר שבע | משרד עו״ד וידבסקי ושות׳"
      description="ייפוי כוח מתמשך — הכנה מקצועית בבאר שבע. מה זה, למי מתאים, איך מכינים ועלות. הגנו על עצמכם ועל יקיריכם — קבעו פגישת ייעוץ עוד היום."
      path="/yipui-koach-metumshach"
      faqItems={faqItems}
      breadcrumbs={[
        { name: "דף הבית", url: "/" },
        { name: "ייפוי כוח מתמשך", url: "/yipui-koach-metumshach" },
      ]}
    />

    {/* Hero */}
    <section className="content_page_hero">
      <div className="container">
        <ul className="breadcrumb">
          <li><Link to="/">דף הבית</Link></li>
          <li>ייפוי כוח מתמשך</li>
        </ul>
        <h1>ייפוי כוח מתמשך</h1>
        <p className="hero_subtitle">
          הגנו על עצמכם ועל יקיריכם — קבעו מראש מי יטפל בענייניכם אם לא תוכלו לעשות זאת.
          משרד וידבסקי ושות׳ ילווה אתכם בתהליך מתחילתו ועד סופו.
        </p>
      </div>
    </section>

    {/* What is it */}
    <section className="page_section">
      <div className="container page_content">
        <div className="page_intro_grid">
          <div>
            <div className="shane_tm_title">
              <span>הסבר כללי</span>
              <h2>מהו ייפוי כוח מתמשך?</h2>
            </div>
            <p>
              ייפוי כוח מתמשך הוא מסמך משפטי המאפשר לכם — בעודכם כשירים — לקבוע
              מי יפעל בשמכם בנושאים רכושיים, אישיים ורפואיים, <strong>אם בעתיד לא
              תוכלו לנהל את ענייניכם בעצמכם</strong> — עקב מחלה, תאונה, דמנציה או
              כל מצב אחר.
            </p>
            <p>
              החוק בישראל מאפשר זאת מכוח חוק הכשרות המשפטית והאפוטרופסות,
              תשכ״ב-1962 (תיקון 18). זהו כלי חשוב ועוצמתי לתכנון עתיד — עבורכם
              ועבור משפחתכם.
            </p>
          </div>
          <div>
            <div className="highlight_box">
              <p>
                💡 <strong>מדוע עדיף ייפוי כוח מתמשך על אפוטרופסות?</strong><br /><br />
                מינוי אפוטרופוס דרך בית המשפט הוא הליך ממושך ויקר, הפוגע
                בפרטיות ובכבוד האדם. ייפוי כוח מתמשך מאפשר לכם לשמור על
                האוטונומיה שלכם ולבחור את מי שיפעל בשמכם — מראש, בתנאים שלכם.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* What can be included */}
    <section className="page_section bg_light">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>תוכן המסמך</span>
          <h2>מה ניתן לכלול בייפוי כוח מתמשך?</h2>
        </div>
        <div className="page_cards">
          {[
            { icon: "🏦", title: "ענייני רכוש וכספים", desc: "ניהול חשבון בנק, מכירה או רכישת נכסים, תשלומים, השקעות וכל עסקה כספית." },
            { icon: "🏥", title: "החלטות רפואיות", desc: "הסכמה לטיפולים רפואיים, בחירת רופאים ומוסדות, טיפול פליאטיבי והנחיות רפואיות מקדימות." },
            { icon: "🏠", title: "ענייני מגורים ורווחה", desc: "בחירת מקום מגורים, הסדרי סיעוד, קשרים חברתיים ואורח חיים כפי שהגדרתם." },
            { icon: "📋", title: "הנחיות מקדימות", desc: "קביעת הנחיות לממונה כיצד לפעול — ערכים, רצונות, גבולות — שישמשו מצפן לקבלת ההחלטות." },
            { icon: "👥", title: "ריבוי ממונים", desc: "מינוי יותר מממונה אחד עם הגדרת תחומים ותנאים, לרבות קביעת ממונה חלופי." },
            { icon: "🔒", title: "פיקוח ובקרה", desc: "קביעת מנגנוני פיקוח על הממונה — כגון חובת דיווח, אישורים נדרשים ועוד." },
          ].map((s) => (
            <div className="card" key={s.title}>
              <div className="card_icon">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Process */}
    <section className="page_section">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>תהליך הכנת המסמך</span>
          <h2>איך מכינים ייפוי כוח מתמשך?</h2>
        </div>
        <p>
          ניתן להכין ייפוי כוח מתמשך רק בעודכם כשירים מבחינה משפטית. ייפוי הכוח
          חייב להיערך בפני עורך דין, ולאחר מכן להיות מופקד אצל האפוטרופוס הכללי.
        </p>
        <div className="page_steps">
          {[
            { n: "1", title: "פגישת ייעוץ והתאמה אישית", desc: "נשמע את רצונותיכם, נסביר את האפשרויות ונתאים את מבנה המסמך לצרכים הספציפיים שלכם ושל משפחתכם." },
            { n: "2", title: "עריכת המסמך וחתימה", desc: "נערוך את ייפוי הכוח בהתאם לדיון, נוודא שהינכם מבינים את כל הסעיפים, ונחתום על המסמך בנוכחות עורך הדין." },
            { n: "3", title: "הפקדה אצל האפוטרופוס הכללי", desc: "נגיש את המסמך לאפוטרופוס הכללי, נשלם את הרישום ונוודא שכל ההליך בוצע כהלכה." },
            { n: "4", title: "שמירת המסמך ועדכון", desc: "נשמור עותק מאושר, נסביר לכם ולממונה מה עליכם לדעת — ונהיה זמינים לכל שאלה בעתיד." },
          ].map((s) => (
            <div className="step" key={s.n}>
              <div className="step_number">{s.n}</div>
              <div className="step_content">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Who needs it */}
    <section className="page_section bg_light">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>למי זה מתאים</span>
          <h2>מי צריך ייפוי כוח מתמשך?</h2>
        </div>
        <div className="page_intro_grid">
          <div>
            <p>
              ייפוי כוח מתמשך מתאים לכל אדם בגיר — לא רק לקשישים. אירועים בלתי
              צפויים כמו תאונות, מחלות קשות או אובדן כשירות פתאומי יכולים לקרות
              לכולנו. ככל שמכינים אותו מוקדם יותר, כך הוא שלם ומשקף יותר את
              רצונותיכם האמיתיים.
            </p>
            <ul>
              <li>בני ובנות 40 ומעלה — תכנון מניעתי מוקדם</li>
              <li>קשישים ובני משפחה הדואגים להוריהם</li>
              <li>אנשים עם מצב רפואי מתדרדר</li>
              <li>כל מי שרוצה לשמור על האוטונומיה שלו</li>
            </ul>
          </div>
          <div>
            <div className="highlight_box">
              <p>
                🛑 <strong>חשוב:</strong> ייפוי כוח מתמשך לא ניתן להכין לאחר
                שהאדם כבר איבד כשירות. ברגע שזה קורה — הדרך היחידה היא פנייה
                לבית המשפט למינוי אפוטרופוס. הכינו את המסמך בזמן.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* FAQ */}
    <section className="page_section">
      <div className="container page_content">
        <div className="shane_tm_title">
          <span>שאלות נפוצות</span>
          <h2>שאלות על ייפוי כוח מתמשך</h2>
        </div>
        <FAQ items={faqItems} />
      </div>
    </section>

    {/* CTA */}
    <section className="page_cta_banner">
      <div className="container">
        <h2>רוצים להכין ייפוי כוח מתמשך?</h2>
        <p>פנו אלינו עוד היום — נלווה אתכם בתהליך כולו, בצורה מקצועית ואישית.</p>
        <div className="cta_buttons">
          <a href={contact.phones[0].href} className="cta_primary">
            התקשרו עכשיו — {contact.phones[0].label}
          </a>
          <button className="cta_secondary" onClick={() => setIsOpen(true)}>
            שלחו הודעה
          </button>
        </div>
      </div>
    </section>
  </PageLayout>
  <ContactModal isOpen={isOpen} setIsOpen={setIsOpen} />
  </>
  );
};

export default PowerOfAttorney;
